import React, { useState } from "react";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { Helpers } from "../../../../helpers/Helpers";
import { GetAntrepoOfferByIdResponseAntrepoOfferDetail } from "../../../../models/response/antrepoOffer/GetAntrepoOfferByIdResponse";
import { GetServiceByIdResponse, GetServiceByIdResponseServiceMultiplier } from "../../../../models/response/service/GetServiceByIdResponse";
import { storeActivityIndicator, storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import { ServiceService } from "../../../../services/ServiceService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { ConstantService } from "../../../../services/ConstantService";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTextInput from "../../../../components/CustomTextInput";
import { PriceService } from "../../../../services/PriceService";
import CustomNumberInput from "../../../../components/CustomNumberInput";
import { GetPriceByIdResponse } from "../../../../models/response/price/GetPriceByIdResponse";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import Tooltip from "../../../../components/Tooltip";
import { OfferStatusEnum } from "../../../../models/common/Enums";
import { AgreementService } from "../../../../services/AgreementService";
import { AddAgreementRequest } from "../../../../models/request/agreement/AddAgreementRequest";
import { AddAgreementResponse } from "../../../../models/response/agreement/AddAgreementResponse";

interface Props {
    offerDetailsRef: any
    antrepoOfferDetails: GetAntrepoOfferByIdResponseAntrepoOfferDetail[]
    setAntrepoOfferDetails: React.Dispatch<React.SetStateAction<GetAntrepoOfferByIdResponseAntrepoOfferDetail[]>>
    isDisabled: boolean
    selectedOfferStatus: CustomSingleSelectModel | undefined
}

const OfferDetails = ({
    offerDetailsRef,
    antrepoOfferDetails,
    setAntrepoOfferDetails,
    isDisabled,
    selectedOfferStatus
}: Props) => {
    const auth = useSelector((state: RootState) => state.auth)
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedService, setSelectedService] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [multiplierList, setMultipierList] = useState<GetServiceByIdResponseServiceMultiplier[]>([]);
    const [selectedMultiplier1, setSelectedMultiplier1] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedMultiplier2, setSelectedMultiplier2] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [unitPrice, setUnitPrice] = useState<string | undefined>(undefined);
    const [minPrice, setMinPrice] = useState<string | undefined>(undefined);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [taxRate, setTaxRate] = useState<string | undefined>(undefined);
    const [description, setDescription] = useState<string | undefined>(undefined);
    const [antrepoOfferDetailId, setAntrepoOfferDetailId] = useState('');
    const [isOpenArea, setIsOpenArea] = useState(false);
    const [isClosedArea, setIsClosedArea] = useState(true);
    const [isHeatControllerRoom, setIsHeatControllerRoom] = useState(false);
    const [selectedHeatControlDetail, setSelectedHeatControlDetail] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPrice, setSelectedPrice] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedAgreement, setSelectedAgreement] = useState<CustomSingleSelectModel | undefined>(undefined);

    const selectAll = () => {
        var isAllSelected = antrepoOfferDetails.length == antrepoOfferDetails.filter(x => x.isSelected).length;

        setAntrepoOfferDetails(antrepoOfferDetails.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setUpdateItem = () => {
        var o = antrepoOfferDetails.filter(x => x.isSelected)[0];

        setAntrepoOfferDetailId(o.antrepoOfferDetailId);
        setSelectedService(o.serviceId ? { label: o.serviceName + '', value: o.serviceId } : undefined);
        setSelectedMultiplier1(o.multiplier1Id ? { label: o.multiplier1Name + '', value: o.multiplier1Id } : undefined);
        setSelectedPotType(o.potTypeId ? { label: o.potTypeName + '', value: o.potTypeId } : undefined);
        setSelectedMultiplier2(o.multiplier2Id ? { label: o.multiplier2Name + '', value: o.multiplier2Id } : undefined);
        setUnitPrice(o.unitPrice);
        setMinPrice(o.minPrice);
        setDescription(o.description);
        setTaxRate(o.taxRate?.toString());
        setSelectedCurrencyType(o.currencyTypeId ? { label: o.currencyTypeName + '', value: o.currencyTypeId } : undefined);
        setSelectedPrice(o.priceId ? { label: o.priceName + '', value: o.priceId } : undefined);
        setSelectedAgreement(o.agreementId ? { label: o.agreementName + '', value: o.agreementId } : undefined);
        setIsOpenArea(o.isOpenArea);
        setIsClosedArea(o.isClosedArea);
        setSelectedHeatControlDetail(o.heatControlDetailId ? { label: o.heatControlDetailName + '', value: o.heatControlDetailId } : undefined);
        setIsHeatControllerRoom(o.isHeatControllerRoom);
        setIsOpen(true);
        scrollTo();
    }

    const setItemSelected = (_id: string) => {
        setAntrepoOfferDetails(antrepoOfferDetails.map(function (x) {
            if (x.antrepoOfferDetailId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const saveItem = (isReset: boolean) => {
        if (!selectedPrice) {
            toast.error('Şablon Adı alanını doldurunuz!')
        }
        else if (!selectedService) {
            toast.error('Hizmet Kalemi alanını doldurunuz!')
        }
        else if (!selectedMultiplier1) {
            toast.error('Çarpan 1 alanını doldurunuz!')
        }
        else if (Helpers.isEmpty(unitPrice)) {
            toast.error('Birim Fiyat alanını doldurunuz!')
        }
        else if (Helpers.isEmpty(minPrice)) {
            toast.error('Min. Fiyat alanını doldurunuz!')
        }
        else if (!selectedCurrencyType) {
            toast.error('Döviz Cinsi alanını doldurunuz!')
        }
        else if (!isOpenArea && !isClosedArea && !isHeatControllerRoom)
            toast.error('Açık Alan veya Kapalı Alan veya Isı Kontrollü Oda alanlarından en az bir tanesi dolu olmalıdır!')
        else if (isHeatControllerRoom && !selectedHeatControlDetail)
            toast.error('Derece alanını doldurunuz!')
        else {
            if (Helpers.isEmpty(antrepoOfferDetailId)) {
                var o: GetAntrepoOfferByIdResponseAntrepoOfferDetail = {
                    antrepoOfferDetailId: Helpers.generateUUID(),
                    isSelected: false,
                    currencyTypeId: selectedCurrencyType?.value,
                    currencyTypeName: selectedCurrencyType?.label,
                    description: description,
                    multiplier1Id: selectedMultiplier1?.value,
                    multiplier1Name: selectedMultiplier1?.label,
                    potTypeId: selectedPotType?.value,
                    potTypeName: selectedPotType?.label,
                    multiplier2Id: selectedMultiplier2?.value,
                    multiplier2Name: selectedMultiplier2?.label,
                    serviceId: selectedService?.value,
                    serviceName: selectedService?.label,
                    unitPrice: Helpers.toNumber(unitPrice).toFixed(2),
                    minPrice: Helpers.toNumber(minPrice).toFixed(2),
                    taxRate: taxRate,
                    isOpenArea: isOpenArea,
                    isClosedArea: isClosedArea,
                    heatControlDetailId: selectedHeatControlDetail?.value,
                    heatControlDetailName: selectedHeatControlDetail?.label,
                    isHeatControllerRoom: isHeatControllerRoom,
                    priceId: selectedPrice?.value,
                    priceName: selectedPrice?.label,
                    agreementId: selectedAgreement?.value,
                    agreementName: selectedAgreement?.label,
                }

                setAntrepoOfferDetails([...antrepoOfferDetails, o])
            }
            else {
                setAntrepoOfferDetails(antrepoOfferDetails.map(function (x) {
                    if (x.antrepoOfferDetailId == antrepoOfferDetailId) {
                        x.isSelected = false;
                        x.currencyTypeId = selectedCurrencyType?.value;
                        x.currencyTypeName = selectedCurrencyType?.label;
                        x.description = description;
                        x.multiplier1Id = selectedMultiplier1?.value;
                        x.multiplier1Name = selectedMultiplier1?.label;
                        x.potTypeId = selectedPotType?.value;
                        x.potTypeName = selectedPotType?.label;
                        x.multiplier2Id = selectedMultiplier2?.value;
                        x.multiplier2Name = selectedMultiplier2?.label;
                        x.serviceId = selectedService?.value;
                        x.serviceName = selectedService?.label;
                        x.unitPrice = Helpers.toNumber(unitPrice).toFixed(2);
                        x.minPrice = Helpers.toNumber(minPrice).toFixed(2);
                        x.taxRate = taxRate;
                        x.isOpenArea = isOpenArea;
                        x.isClosedArea = isClosedArea;
                        x.heatControlDetailId = selectedHeatControlDetail?.value;
                        x.heatControlDetailName = selectedHeatControlDetail?.label;
                        x.isHeatControllerRoom = isHeatControllerRoom;
                        x.priceId = selectedPrice?.value;
                        x.priceName = selectedPrice?.label;
                        x.agreementId = selectedAgreement?.value;
                        x.agreementName = selectedAgreement?.label;
                    }

                    return x;
                }))
            }

            setAntrepoOfferDetailId('');
            setSelectedService(undefined);
            setMultipierList([]);
            setSelectedMultiplier1(undefined);
            setSelectedPotType(undefined);
            setSelectedMultiplier2(undefined);
            setUnitPrice('');
            setMinPrice('');
            setDescription('');
            setTaxRate('');
            setSelectedCurrencyType(undefined);
            setSelectedPrice(undefined);
            setSelectedAgreement(undefined);
            setIsOpenArea(false);
            setIsClosedArea(true);
            setSelectedHeatControlDetail(undefined);
            setIsHeatControllerRoom(false);

            if (!isReset) {
                setIsOpen(false);
                scrollTo();
            }
        }
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAntrepoOfferDetailId('');
        setSelectedService(undefined);
        setMultipierList([]);
        setSelectedMultiplier1(undefined);
        setSelectedPotType(undefined);
        setSelectedMultiplier2(undefined);
        setUnitPrice('');
        setMinPrice('');
        setDescription('');
        setTaxRate('');
        setSelectedCurrencyType(undefined);
        setSelectedPrice(undefined);
        setSelectedAgreement(undefined);
        setIsOpenArea(false);
        setIsClosedArea(true);
        setSelectedHeatControlDetail(undefined);
        setIsHeatControllerRoom(false);
        setIsOpen(false);
        scrollTo();
    }

    const deleteItems = () => {
        setAntrepoOfferDetails(antrepoOfferDetails.filter(x => !x.isSelected));
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = offerDetailsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const onPriceSelected = async (selectedValue: CustomSingleSelectModel | undefined) => {
        try {
            if (!selectedValue) {
                return;
            }

            dispatch(storeActivityIndicator(true));

            var response: GetPriceByIdResponse = await PriceService.getPriceById(selectedValue.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            // if (response.data.productKindId)
            //     setSelectedProductKind({ label: response.data.productKindName, value: response.data.productKindId });

            if (response.data.potTypeId)
                setSelectedPotType({ label: response.data.potTypeName, value: response.data.potTypeId });

            if (response.data.serviceId) {
                setSelectedService({ label: response.data.serviceName, value: response.data.serviceId, additionalValue1: response.data.serviceKey });
                setTaxRate(response.data.serviceKey);
            }

            if (response.data.multiplier1Id)
                setSelectedMultiplier1({ label: response.data.multiplier1Name, value: response.data.multiplier1Id });

            if (response.data.multiplier2Id)
                setSelectedMultiplier2({ label: response.data.multiplier2Name, value: response.data.multiplier2Id });

            setUnitPrice(response.data.unitPrice?.toString());

            if (response.data.currencyTypeId)
                setSelectedCurrencyType({ label: response.data.currencyTypeName, value: response.data.currencyTypeId });

            setMinPrice(response.data.minPrice?.toString());

            if (response.data.heatControlDetailId)
                setSelectedHeatControlDetail({ label: response.data.heatControlDetailName, value: response.data.heatControlDetailId });
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const redirectToPriceList = () => {
        window.open(window.location.href.split('?')[0].replace('antrepooffer', 'price').replace('listadd', 'list'), "_blank")
    }

    const saveAgreement = async (_insertedValue: string) => {
        try {
            dispatch(storeActivityIndicator(true));

            var o: AddAgreementRequest = {
                agreementId: undefined,
                endDate: undefined,
                heatControlDetailId: undefined,
                isClosedArea: false,
                isCustomActive: true,
                isHeatControllerRoom: false,
                isIncome: false,
                isOpenArea: false,
                isOutcome: false,
                name: _insertedValue,
                productKindId: undefined,
                refNo: undefined,
                selectedCompanyId: undefined,
                startDate: undefined,
                agreementDetails: []
            }

            var response: AddAgreementResponse = await AgreementService.addAgreement(o);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));

            setSelectedAgreement({ label: response.data.name, value: response.data.agreementId });
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <div className='containerPart' ref={offerDetailsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Teklif Detayları</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Açık Alan</label>
                                        <CustomSwitch disabled={isDisabled} isActive={isOpenArea} setIsActive={() => {
                                            setSelectedHeatControlDetail(undefined);
                                            setIsOpenArea(!isOpenArea);
                                            setIsClosedArea(false);
                                            setIsHeatControllerRoom(false);
                                            setSelectedPrice(undefined);
                                        }} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kapalı Alan</label>
                                        <CustomSwitch disabled={isDisabled} isActive={isClosedArea} setIsActive={() => {
                                            setSelectedHeatControlDetail(undefined);
                                            setIsOpenArea(false);
                                            setIsClosedArea(!isClosedArea);
                                            setIsHeatControllerRoom(false);
                                            setSelectedPrice(undefined);
                                        }} />
                                    </div>

                                    <div className="col-md-4">
                                        <Box flexDirection="row" gap="15px">
                                            <Box>
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Isı Kontrollü Oda</label>
                                                <CustomSwitch disabled={isDisabled} isActive={isHeatControllerRoom} setIsActive={() => {
                                                    setSelectedHeatControlDetail(undefined);
                                                    setIsOpenArea(false);
                                                    setIsClosedArea(false);
                                                    setIsHeatControllerRoom(!isHeatControllerRoom);
                                                    setSelectedPrice(undefined);
                                                }} />
                                            </Box>

                                            {
                                                isHeatControllerRoom && (
                                                    <Box flexGrow={1}>
                                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Derece</label>

                                                        <CustomSingleSelect
                                                            disabled={isDisabled}
                                                            selectedValue={selectedHeatControlDetail}
                                                            onChange={(selectedValue) => {
                                                                setSelectedHeatControlDetail(selectedValue);
                                                                setSelectedPrice(undefined);
                                                            }}
                                                            insertable={{
                                                                onSubmit: { code: 'HEAT_CONTROL_DETAIL' }
                                                            }}
                                                            onMenuOpen={() => ConstantService.getConstantList('HEAT_CONTROL_DETAIL')}
                                                            labelName='value'
                                                            valueName='constantId'
                                                        />
                                                    </Box>
                                                )
                                            }

                                        </Box>
                                    </div>
                                </div>

                                <div className='row mt-5'>
                                    <div className="col-md-4">
                                        <Box mb="0.5rem" flexDirection="row">
                                            <Box justifyContent="flex-start">
                                                <label htmlFor="exampleFormControlInput1" className="mb-0 form-label required">Şablon Adı</label>
                                            </Box>
                                            <Box ml="5px" justifyContent="center">
                                                <Tooltip content={'Depolama Yeri - Derece - Hizmet Kalemi - Ürün Cinsi - Kap Cinsi - (Çarpan 1 * Çarpan 2 * Birim Fiyat)'} direction={'right'}>
                                                    <i className="actionIcon fs-6 text-primary fa fa-info-circle" />
                                                </Tooltip>
                                            </Box>
                                        </Box>

                                        <CustomSingleSelect
                                            disabled={isDisabled || (!isOpenArea && !isClosedArea && !isHeatControllerRoom) || (isHeatControllerRoom && !selectedHeatControlDetail)}
                                            selectedValue={selectedPrice}
                                            onChange={(selectedItem) => {
                                                setSelectedPrice(selectedItem);
                                                onPriceSelected(selectedItem);
                                            }}
                                            onMenuOpen={() => PriceService.getPriceList(true, isOpenArea ? true : undefined, isClosedArea ? true : undefined, isHeatControllerRoom ? true : undefined, selectedHeatControlDetail?.value)}
                                            labelName='name'
                                            valueName='priceId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Çarpan 1</label>

                                        <CustomSingleSelect
                                            disabled
                                            selectedValue={selectedMultiplier1}
                                            onChange={setSelectedMultiplier1}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: multiplierList
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Döviz Cinsi</label>

                                        <CustomSingleSelect
                                            disabled
                                            selectedValue={selectedCurrencyType}
                                            onChange={setSelectedCurrencyType}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                                            labelName='additionalValue1'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Hizmet Kalemi</label>

                                        <CustomSingleSelect
                                            disabled
                                            selectedValue={selectedService}
                                            onChange={setSelectedService}
                                            onMenuOpen={() => ServiceService.getServiceList(true)}
                                            labelName='name'
                                            valueName='serviceId'
                                            additionalValue1Name={'incomePercentageName'}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput2" className="form-label">Çarpan 2</label>

                                        <CustomSingleSelect
                                            disabled
                                            selectedValue={selectedMultiplier2}
                                            onChange={setSelectedMultiplier2}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: multiplierList
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                        <CustomTextInput isDisabled={isDisabled} value={description} setValue={setDescription} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kap Cinsi</label>

                                        <CustomSingleSelect
                                            disabled
                                            selectedValue={selectedPotType}
                                            onChange={setSelectedPotType}
                                            onMenuOpen={() => ConstantService.getConstantList('POT_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Birim Fiyat</label>
                                        <CustomNumberInput isDisabled={isDisabled} value={unitPrice} setValue={setUnitPrice} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Min. Fiyat</label>
                                        <CustomNumberInput isDisabled={isDisabled} value={minPrice} setValue={setMinPrice} />
                                    </div>
                                </div>

                                {(selectedOfferStatus && selectedOfferStatus.additionalValue1 == OfferStatusEnum.ONAYLANDI) && (
                                    <div className="row mt-5">
                                        <div className="col-md-4">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Anlaşma Adı</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedAgreement}
                                                onChange={setSelectedAgreement}
                                                onMenuOpen={() => AgreementService.getAgreementList(true, undefined, undefined, undefined, undefined, undefined)}
                                                insertable={{
                                                    onSubmit: {
                                                        onSubmit: (_insertedValue) => {
                                                            saveAgreement(_insertedValue);
                                                        }
                                                    }
                                                }}
                                                labelName='name'
                                                valueName='agreementId'
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box flexDirection="row">
                                                {
                                                    !isDisabled && (
                                                        <Box bg="orange" mr="15px" onClick={() => saveItem(true)} className="actionIcon p-2" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                            <Box mr="5px" justifyContent="center">
                                                                <i className="text-white fa fa-refresh" />
                                                            </Box>
                                                            <Box justifyContent="center">
                                                                <span style={{ fontWeight: 600 }} className="text-white">Kaydet & Yeni Kayıt</span>
                                                            </Box>
                                                        </Box>

                                                    )
                                                }

                                                <Box onClick={() => saveItem(false)} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                    <Box mr="5px" justifyContent="center">
                                                        <i className="text-white fa fa-check" />
                                                    </Box>
                                                    <Box justifyContent="center">
                                                        <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={isDisabled ? undefined : cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={!isDisabled ? "1" : "0.5"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={antrepoOfferDetails.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={antrepoOfferDetails.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>

                        <Box onClick={!isDisabled && antrepoOfferDetails.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={!isDisabled && antrepoOfferDetails.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>

                        {
                            auth.user.user?.data.authorizedMenus.find(x => "Antrepo Modülü > Anlaşmalar > Fiyat Listesi") && (
                                <Box onClick={!isDisabled ? redirectToPriceList : undefined} opacity={!isDisabled ? "1" : "0.5"} ml="10px" bg="purple" className="actionIcon p-2" justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className="text-white fa fa-list" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">Fiyat Listesi</span>
                                    </Box>
                                </Box>
                            )
                        }
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input /*disabled={isDisabled}*/ onChange={selectAll} className='form-check-input' type='checkbox' checked={antrepoOfferDetails.filter(x => x.isSelected).length > 0 && antrepoOfferDetails.filter(x => x.isSelected).length == antrepoOfferDetails.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Şablon Adı</th>
                                            {(selectedOfferStatus && selectedOfferStatus.additionalValue1 == OfferStatusEnum.ONAYLANDI) && <th>Anlaşma Adı</th>}
                                            <th>Hizmet Kalemi</th>
                                            <th>Kap Cinsi</th>
                                            <th>Çarpan 1</th>
                                            <th>Çarpan 2</th>
                                            <th>Birim Fiyat</th>
                                            <th>Min. Fiyat</th>
                                            <th>Döviz Cinsi</th>
                                            <th>KDV Oranı</th>
                                            <th>Açıklama</th>
                                            <th>Açık Alan</th>
                                            <th>Kapalı Alan</th>
                                            <th>Isı Kontrollü Oda</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoOfferDetails.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoOfferDetails.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input /*disabled={isDisabled}*/ onChange={() => setItemSelected(item.antrepoOfferDetailId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.priceName}</td>
                                                    {(selectedOfferStatus && selectedOfferStatus.additionalValue1 == OfferStatusEnum.ONAYLANDI) && <td>{item.agreementName}</td>}
                                                    <td>{item.serviceName}</td>
                                                    <td>{item.potTypeName}</td>
                                                    <td>{item.multiplier1Name}</td>
                                                    <td>{item.multiplier2Name}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.unitPrice)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.minPrice)}</td>
                                                    <td>{item.currencyTypeName}</td>
                                                    <td>{item.taxRate ? (item.taxRate?.toString()?.replace('%', '') + '%') : ''}</td>
                                                    <td>{item.description}</td>
                                                    <td>{item.isOpenArea ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                    <td>{item.isClosedArea ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                    <td>
                                                        <Box flexDirection="row">
                                                            <Box justifyContent="center">
                                                                {item.isHeatControllerRoom ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}
                                                            </Box>
                                                            {
                                                                !Helpers.isEmpty(item.heatControlDetailName) && (
                                                                    <Box ml="5px" justifyContent="center">
                                                                        ({item.heatControlDetailName})
                                                                    </Box>
                                                                )
                                                            }
                                                        </Box>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default OfferDetails;